const state = {
  dailyList: [],
  paperList: [], 
  shareBoardCount:0,
  noneReadCount:0,
  cfrcNoneReadCount:0,
  // 관리자 권한이 있는 지 .
  shareInfoManageYn: false,
  cooperationManageYn : false,
  cooperationManageCountYn : false,
  // 운영자 권한이 있는 카테고리 .
  shareInfoManageCategoryCount : 0,
};
const actions = {};
const mutations = {
  setShareInfoList(state, payload) {
    state.dailyList = payload.dailyList;
    state.paperList = payload.paperList;
  }, 
  setShareBoardCount(state, payload){
    if(payload == -1){
      state.shareBoardCount=0;
    }else{
      state.shareBoardCount += payload;
    }
  },
  setNoneReadCount(state , payload){
    if(payload == -1){
      state.noneReadCount =0;
    }else{
      state.noneReadCount += payload;
    }
  },
  setCfrcNoneReadCount(state, payload){
    if(payload == -1){
      state.cfrcNoneReadCount = 0 ;
    }else{
      state.cfrcNoneReadCount += payload;
    }
  },
  // 관리자 권한 set 
  setShareInfoManageYn(state, payload){
    state.shareInfoManageYn = payload;
  },
  setCooperationManageYn(state, payload){ 
    state.cooperationManageYn = payload; 
  },
  // 운영자 권한 이있는 카테고리 카운트.
  setShareInfoManageCategoryCount(state, payload){
      state.shareInfoManageCategoryCount = payload;
  },
  setCooperationManageCountYn(state, payload){
    state.cooperationManageCountYn = payload;
  }
};
const getters = {};

export default { state, actions, mutations, getters, namespaced: true };



// WEBPACK FOOTER //
// ./src/js/store/module/shareInfo/shareInfo.js